import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "@/lib/analytics";

/**
 * Sends a page view on first render and on every React Router navigation.
 *
 * Mounted once, in Layout. The SPA never does a full page load after boot, so
 * without this the site records exactly one page view per session no matter how
 * many pages the visitor reads.
 */
export function usePageTracking(): void {
  const location = useLocation();
  useEffect(() => {
    const uri = location.pathname + location.search;
    trackPageView(location.pathname, uri);
  }, [location.pathname, location.search]);
}
